// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fIrI","title":"styles_title__3Gvai","subtitle":"styles_subtitle__356-R","header":"styles_header__Gm18o"};